"use client";
import * as e from "react";
const t = /* @__PURE__ */ e.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (t.displayName = "CompositeListContext");
function s() {
  return e.useContext(t);
}
export {
  t as C,
  s as u
};
